export default {
  en: {
    filterByLabel: 'Filter by %{filterCategory}:',
    applyButtonLabel: 'Apply',
    clearButtonLabel: 'Clear'
  },
  fr: {
    filterByLabel: 'Filtrer par %{filterCategory}:',
    applyButtonLabel: 'Appliquer',
    clearButtonLabel: 'Effacer'
  }
};